import { Menu, Transition } from '@headlessui/react'
import { Fragment, useEffect, useRef, useState } from 'react'
import { AiOutlineLogout } from 'react-icons/ai';
import { IoMailOutline } from 'react-icons/io5';
import { RiUserSettingsLine } from 'react-icons/ri';
import { Navigate, useNavigate } from 'react-router-dom';
import { UserResponse } from '../api/responses';
import { logout } from '../utils';

export default function HeaderAvatarMenu({ user }: { user: UserResponse }) {
  const navigate = useNavigate();

  const userInitials = user?.name ? user?.name.split(" ").map((name: string) => name[0]?.toUpperCase()).join('') : 'U'

  return (
    <div className="">
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className="bg-gray-200 w-12 h-12 font-bold shadow rounded-full mr-4 border border-gray-300">
            {userInitials}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 mt-2 w-72 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="px-1 py-1 ">
              <div className="flex py-4 px-2">
                <div className="bg-gray-200 w-12 h-12 font-bold shadow rounded-full mr-2 flex justify-center items-center">
                  {userInitials}
                </div>
                <div className='flex-1'>
                  <p>{user?.name || "No Name"}</p>
                  <p className="text-gray-400">{user?.email}</p>
                </div>
              </div>
              {/* <div className="px-3">Current Plan</div> */}
              <div className='h-[1px] bg-gray-200'></div>
              
              <div className='pt-3'>

              {/* <Menu.Item>
                <button onClick={() => {}} className="text-primary w-full inline-block text-left px-3 py-2 hover:bg-gray-100 rounded-lg">
                  <RiUserSettingsLine  className='inline'/>&nbsp;&nbsp;Current Plan
                </button>
              </Menu.Item> */}

              <Menu.Item>
                <a href="mailto:hello@monitorly.co" className="text-primary w-full inline-block text-left px-3 py-2 hover:bg-gray-100 rounded-lg">
                  <IoMailOutline size={20} className='inline -mt-1'/>&nbsp;&nbsp;Contact Us
                </a>
              </Menu.Item>

              <Menu.Item>
                <button onClick={() => {navigate("/dashboard/settings/general")}} className="text-primary w-full inline-block text-left px-3 py-2 hover:bg-gray-100 rounded-lg">
                  <RiUserSettingsLine size={20} className='inline'/>&nbsp;&nbsp;Account Settings
                </button>
              </Menu.Item>
              
              <Menu.Item>
                {({ active }) => (
                  <button
                  onClick={(e)=>{
                    logout();
                  }}
                  className="text-red-500 w-full inline-block text-left px-3 py-2 hover:bg-red-100 rounded-lg"
                  >
                    <AiOutlineLogout className='inline' />&nbsp;&nbsp;
                    Logout
                  </button>
                )}
              </Menu.Item>
              </div>
            </div>
          </Menu.Items> 
        </Transition>
      </Menu>
    </div>
  )
}